import type { CapCertificationSummary, CapSubmissionSummary } from '@dosfilos/domain';

// ─── Qué ofrecer al centro después de someter, según lo que respondió TMAI ──
//
// Puro a propósito: es la decisión que más fácil se rompe en silencio, y la que
// más cuesta cuando se rompe — un botón "Presentar" de más manda a TMAI una
// evidencia que ya respondió; uno de menos deja al centro sin camino.

/** Una SOLICITUD devuelta o rechazada pide una versión nueva: volver a presentar
 *  la misma versión mandaría a TMAI la evidencia que ya respondió. Una CONSULTA
 *  respondida no: pedía comentarios, y el centro puede presentar su solicitud. */
export function roundAsksForNewVersion(round: CapSubmissionSummary): boolean {
  return (
    round.submissionKind === 'formal' &&
    (round.status === 'returned' || round.status === 'rejected')
  );
}

export interface ProposalReviewActions {
  /** Ofrecer "Presentar a TMAI". */
  canPresent: boolean;
  /** Reabrir como nueva versión es la respuesta esperada: acción primaria. */
  asksNewVersion: boolean;
}

export function proposalReviewActions(input: {
  /** Rondas del programa + CAP + nivel, en cualquier orden. */
  rounds: CapSubmissionSummary[];
  certification: CapCertificationSummary | null;
  proposalId: string;
}): ProposalReviewActions {
  // El servidor rechaza una segunda ronda con otra abierta del mismo programa,
  // CAP y nivel — sea de esta versión o de otra. Eso sí bloquea.
  const openRound = input.rounds.some((r) => r.status === 'submitted');
  const latestForThis = input.rounds
    .filter((r) => r.proposalId === input.proposalId)
    .sort((a, b) => b.round - a.round)[0];
  const asksNewVersion = !!latestForThis && roundAsksForNewVersion(latestForThis);
  // ESTAR CERTIFICADO NO BLOQUEA, y esto cambió. La regla decía `!certified`,
  // escrita cuando certificarse era el final del camino. Dejó de serlo:
  //  · una certificación otorgada CON CONDICIONES se cierra presentando una
  //    ronda nueva —es la única forma de cerrarlas—, y prohibir presentar
  //    dejaba al centro sin manera de cumplir lo que TMAI le pidió;
  //  · un programa que mejora su malla puede querer volver a presentarla.
  // El servidor nunca lo impidió: era una puerta cerrada sólo en la pantalla.
  return { canPresent: !openRound && !asksNewVersion, asksNewVersion };
}
